import { render, staticRenderFns } from "./ArchiveMap.vue?vue&type=template&id=15f2939a&scoped=true&"
import script from "./ArchiveMap.vue?vue&type=script&lang=js&"
export * from "./ArchiveMap.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveMap.vue?vue&type=style&index=0&id=15f2939a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f2939a",
  null
  
)

export default component.exports